import React from "react";
import LojaModel from "./model/LojaModel";
import AppState from "./model/AppState";
import C5DataRetiradaModel from "./model/C5DataRetiradaModel";
import DataUtil from "./util/DataUtil";
import C5RetiradaDAO from "./dataAccess/C5/C5RetiradaDAO";
import MockData from "./model/MockData";
import C5RetiradaItemModel from "./model/C5RetiradaItemModel";
import AgendamentoRetiradaModel from "./model/AgendamentoRetiradaModel";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface IAgendamentoRetiradaProps extends RouteComponentProps {}

type AgendamentoRetiradaState = {
  datasRetirada: C5DataRetiradaModel[];
  diaSelecionado: C5DataRetiradaModel | undefined;
  carregando: boolean;
};

class AgendamentoRetirada extends React.Component<
  IAgendamentoRetiradaProps,
  AgendamentoRetiradaState
> {
  constructor(props: IAgendamentoRetiradaProps) {
    super(props);
    this.state = {
      datasRetirada: [],
      diaSelecionado: undefined,
      carregando: true,
    };
    this.changeDay = this.changeDay.bind(this);
    this.agendar = this.agendar.bind(this);
  }

  componentDidMount(): any {
    LogUtil.logPage("Agendamento de retirada");
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja) {
      if (!AppState.getMockData()) {
        C5RetiradaDAO.getInstance()
          .getRetiradaOpcoes(loja)
          .then((datas: C5DataRetiradaModel[]) => {
            LogUtil.logObject(datas, this);
            LogUtil.logHorariosAgendamento("retirada", datas, AppState.getUsuarioLogado());
            this.setState({
              datasRetirada: datas,
              diaSelecionado: datas.length > 0 ? datas[0] : undefined,
              carregando: false,
            });
          });
      } else {
        this.setState({
          datasRetirada: MockData.getAgendamentoRetiradas(),
          diaSelecionado:
            MockData.getAgendamentoRetiradas().length > 0
              ? MockData.getAgendamentoRetiradas()[0]
              : undefined,
          carregando: false,
        });
      }
    } else {
      NavegadorUtil.redirect("/lojas", this.props.history);
    }
  }

  changeDay(diaSelecionado: C5DataRetiradaModel): any {
    this.setState({ diaSelecionado });
  }

  naoImprimiuHorario(
    item: C5RetiradaItemModel,
    todos: C5RetiradaItemModel[]
  ): boolean {
    const items: C5RetiradaItemModel[] = todos.filter(
      (r: C5RetiradaItemModel) => {
        return (
          item.ScheduleID > r.ScheduleID &&
          item.DeliveryDate === r.DeliveryDate &&
          item.DeliveryHour === r.DeliveryHour
        );
      }
    );

    return items.length === 0;
  }

  setAgendamento(agendamentoId: string, titulo: string): void {
    AppState.setAgendamentoRetirada({
      agendamentoId,
      titulo,
    });
    AppState.setDescricaoEntrega("Agendamento de retirada");
  }

  agendar(): void {
    const agendamento: AgendamentoRetiradaModel | null = AppState.getAgendamentoRetirada();

    if (agendamento) {
      NavegadorUtil.redirect("/forma-pagamento", this.props.history);
    }
  }

  render(): any {
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    let count: number = 0;
    const { datasRetirada, diaSelecionado, carregando } = this.state;

    if (loja) {
      if (carregando) {
        return (
          <section className="lists white-bg">
            <div className="header">
              <BotaoVoltar titulo="Carregando..."></BotaoVoltar>
            </div>
          </section>
        );
      } else {
        return (
          <section className="lists payment white-bg">
            <div className="header">
              <BotaoVoltar
                titulo="Agendamento de retirada"
                url="/carrinho"
              ></BotaoVoltar>
            </div>
            <div className="store-pickup">
              <p className="title">Loja:</p>
              <p>
                {loja.nome} - {loja.logradouro}, {loja.numero} - {loja.bairro},{" "}
                {loja.cidade} - {loja.uf}, {loja.cep}
              </p>
              <br />
              <p className="title">Caso o produto não esteja disponível:</p>
              <p>{AppState.getProdutoAlternativo()}</p>
            </div>
            <div className="hours">
              <h2>Quando gostaria de buscar seu pedido?</h2>
              <div className="days">
                {datasRetirada &&
                  datasRetirada.map((dia: C5DataRetiradaModel) => {
                    const isActive: boolean | undefined =
                      diaSelecionado &&
                      DataUtil.getDMA(dia.dataEntrega) ===
                        DataUtil.getDMA(diaSelecionado.dataEntrega);
                    if (++count <= 7) {
                      return (
                        <div
                          className={`day ${isActive ? "active" : ""}`}
                          key={DataUtil.getDMA(dia.dataEntrega)}
                          onClick={() => this.changeDay(dia)}
                        >
                          <span>{DataUtil.getDiaDMA(dia.dataEntrega)}</span>
                          <br />
                          {DataUtil.getDiaSemanaDMA(dia.dataEntrega)}
                        </div>
                      );
                    } else {
                      return "";
                    }
                  })}
              </div>
              <ul className="hours">
                {diaSelecionado &&
                  diaSelecionado !== undefined &&
                  diaSelecionado.itens &&
                  diaSelecionado.itens.map(
                    (a: C5RetiradaItemModel) =>
                      this.naoImprimiuHorario(a, diaSelecionado.itens) && (
                        <li key={a.ScheduleID}>
                          <input
                            type="radio"
                            name="schedule"
                            id={`i${a.ScheduleID}`}
                            value={a.ScheduleID}
                            onChange={(e) =>
                              this.setAgendamento(
                                e.target.value as string,
                                `${DataUtil.getDMA(
                                  diaSelecionado.dataEntrega
                                )} - das ${a.DeliveryHour}`
                              )
                            }
                          />
                          <label htmlFor={`i${a.ScheduleID}`}>
                            {a.DeliveryHour}
                          </label>
                        </li>
                      )
                  )}
              </ul>
            </div>
            <button className="main-button inactive" onClick={this.agendar}>
              Agendar
            </button>
          </section>
        );
      }
    } else {
      NavegadorUtil.redirect("/lojas", this.props.history);
    }
  }
}

export default withRouter(AgendamentoRetirada);
